<template>
  <div :style="themeStyle">
    <v-container class="pt-10">

        <v-dialog v-model="loading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0 btn_icon1"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="failed"
          persistent
        >
          <v-card class="pa-7">
            <v-row>
              <v-col class="text-center"><v-img src="/static/img/oops.svg" /></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0"><span class="headline2 font18" v-html="message"></span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  dark
                  @click="$router.push('home')"
                >
                  ดูคะแนนสะสม และ ของรางวัล
                </v-btn>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="success"
          persistent
        >
          <v-card class="pa-7">
            <v-row>
              <v-col class="text-center"><img
                    style="
                      border-color: white;
                      height: 100px;
                    "
                    alt="Avatar"
                    :src="require('@/assets/coin.png')"
                  /></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pb-0"><span class="headline1 font28 weight1000">คุณได้รับคะแนนเพิ่ม</span></v-col>
            </v-row>
            <v-row v-if="point">
              <v-col class="text-center pa-0"><span class="headline1 font55 weight1000">{{point}}</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0"><span class="headline1 font28 weight1000">คะแนน</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  dark
                  @click="$router.push('home')"
                >
                  ดูคะแนนสะสม และ ของรางวัล
                </v-btn>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-bottom-sheet v-if="levelUpdate"
          v-model="levelup"
          persistent
          hide-on-scroll
          overlay-opacity="1"
        >
          <v-sheet
            class="text-center"
            height="100vh"
          >
            <v-img src="/static/img/papershoot.png" style="position:absolute;top:0;" />
            <!-- <v-img src="/static/img/golden.png" max-width="300" max-height="392" style="position:absolute;top:60px;left:35px;" /> -->
            <v-row style="padding-top:20px;">
              <v-col class="text-center pb-0"><span class="headline1 font55 bold">Congrats!</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pb-0"><span class="headline2 font18 bold">คุณได้รับคะแนนเพิ่ม</span></v-col>
            </v-row>
            <v-row v-if="point">
              <v-col class="text-center pa-0"><span class="headline2 font24 weight1000">{{point}}</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0"><span class="headline2 font18 bold">คะแนน</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0 pb-0"><span class="headline1 font24 bold">และได้อัพเกรดเป็นสมาชิก</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0 pb-3"><span class="headline1 font28 weight1000">{{levelUpdate.name}}</span></v-col>
            </v-row>
            <v-row>
              <v-col class="ml-5 mr-5 text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  dark
                  @click="$router.push('privilege')"
                >
                  ดูสิทธิประโยชน์ที่ได้รับเพื่มเติม
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>
        </v-bottom-sheet>

    </v-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
export default {
  name: 'PointCollect',
  data () {
    return {
      loading: true,
      success: false,
      levelup: false,
      failed: false,
      token: null,
      point: null,
      message: null,
      level: null,
      member: null,
      levelUpdate: null,
      findUser: null,
      profile: [],
      dataMember: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.token = this.$route.query.token

    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.dataMember = await this.callBeTaskAPI('get', '/member/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId)
    if (this.member === null) {
      this.findUser = false
    } else {
      this.findUser = true
    }
    if (this.token === '') {
      this.message = 'รหัสรับคะแนนไม่ถูกต้อง<br>กรุณาติดต่อเจ้าหน้าที่ค่ะ'
      this.success = false
      this.levelup = false
      this.loading = false
      this.failed = true
    } else if (this.findUser) {
      if (Array.isArray(this.dataMember) === false) {
        const currentUrl = window.location.pathname
        const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
        this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&memberId=${this.member.memberId}&redirectUrl=${redirectUrl}`)
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showPosition, this.notShowPosition)
        } else {
          await this.collectPoint2()
        }
      }
    } else if (!this.findUser) {
      await axios.get(this.DNS_IP + '/qrcode/get?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token).then(async result => {
        if (result.data.status === undefined) {
          if (result.data[0].status === 'waiting') {
            Swal.fire({
              title: '<h2>ต้องการสมัครสมาชิก ใช่หรือไม่?</h2>',
              showCancelButton: true,
              allowOutsideClick: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'สมัครสมาชิก',
              cancelButtonText: 'ยกเลิก'
            }).then(async (confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&token=${this.$route.query.token}`)
              } else {
                this.$router.push('/bankPage')
              }
            })
          } else {
            this.success = false
            this.levelup = false
            this.failed = true
            this.message = 'ขออภัย!<br>คุณเคยได้รับคะแนนไปแล้ว'
          }
        } else {
          this.message = 'รหัสรับคะแนนไม่ถูกต้อง<br>กรุณาติดต่อเจ้าหน้าที่ครับ'
          this.success = false
          this.levelup = false
          this.failed = true
        }
      })
    }
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    showPosition (position) {
      let latitude = position.coords.latitude
      let longitude = position.coords.longitude
      this.collectPoint(position.coords.latitude, position.coords.longitude)
    },
    async notShowPosition () {
      try {
        await this.collectPoint2()
      } catch (error) {
        alert(error)
      }
      // this.collectPoint()
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
      if (result) {
        if (result.length > 0) {
          this.setLevel(result)
          return result
        }
      }
    },
    async collectPoint (latitude, longitude) {
      try {
        const params = {
          'token': this.token,
          'name': this.profile.displayName,
          'picture': this.profile.pictureUrl
        }
        if (latitude && longitude) {
          params.latitude = latitude
          params.longitude = longitude
          await axios.get(this.DNS_IP + `/getGoogleLocation?latitude=${latitude}&longitude=${longitude}&token=${this.token}`)
        }
        const result = await this.callBeTaskAPI('post', `/memberCard/edit`, params)
        this.loading = false
        if (result) {
          if (result.status) {
            this.level = await this.getLevelDB()
            this.member = await this.GET_MEMBERINFO()
            if (this.member === null) {
              await this.getMemberProfile()
              this.member = this.GET_MEMBERINFO()
            }
            this.failed = false
            this.point = result.point
            if (result.subPoint) {
              this.success = true
            } else if (!result.subPoint) {
              this.levelUpdate = this.level.filter((item) => parseInt(item.levelId) === parseInt(result.level))[0]
              // console.log('this.member', this.member)
              if (typeof this.member.levelId === 'undefined') {
                this.success = true
              } else if (parseInt(this.member.levelId) === parseInt(this.levelUpdate.levelId)) {
                this.success = true
              } else {
                this.levelup = true
              }
            }
            await this.getMemberProfile()
            this.member = this.GET_MEMBERINFO()
          } else {
            this.success = false
            this.levelup = false
            this.failed = true
            this.message = 'ขออภัย!<br>คุณเคยได้รับคะแนนไปแล้ว'
          }
        } else {
          this.message = 'รหัสรับคะแนนไม่ถูกต้อง<br>กรุณาติดต่อเจ้าหน้าที่ครับ'
          this.success = false
          this.levelup = false
          this.failed = true
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async collectPoint2 () {
      try {
        const params = {
          'token': this.token,
          'name': this.profile.displayName,
          'picture': this.profile.pictureUrl
        }
        const result = await this.callBeTaskAPI('post', `/memberCard/edit`, params)
        this.loading = false
        if (result) {
          if (result.status) {
            this.level = await this.getLevelDB()
            this.member = await this.GET_MEMBERINFO()
            if (this.member === null) {
              await this.getMemberProfile()
              this.member = this.GET_MEMBERINFO()
            }
            this.failed = false
            this.point = result.point
            if (result.subPoint) {
              this.success = true
            } else if (!result.subPoint) {
              this.levelUpdate = this.level.filter((item) => parseInt(item.levelId) === parseInt(result.level))[0]
              // console.log('this.member', this.member)
              if (typeof this.member.levelId === 'undefined') {
                this.success = true
              } else if (parseInt(this.member.levelId) === parseInt(this.levelUpdate.levelId)) {
                this.success = true
              } else {
                this.levelup = true
              }
            }
            await this.getMemberProfile()
            this.member = this.GET_MEMBERINFO()
          } else {
            this.success = false
            this.levelup = false
            this.failed = true
            this.message = 'ขออภัย!<br>คุณเคยได้รับคะแนนไปแล้ว'
          }
        } else {
          this.message = 'รหัสรับคะแนนไม่ถูกต้อง<br>กรุณาติดต่อเจ้าหน้าที่ครับ'
          this.success = false
          this.levelup = false
          this.failed = true
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Point/Collect.vue